import { render, staticRenderFns } from "./check_standard_list.vue?vue&type=template&id=5ec5b67a&"
import script from "./check_standard_list.vue?vue&type=script&lang=js&"
export * from "./check_standard_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports